module.exports = __webpack_public_path__ + "43a169408ea911060f48f0997cafedff.png";